module.exports = __webpack_public_path__ + "static/img/logo.e3c8a985.png";